<ng-container *ngIf="!showFullMenu">
    <div class="top-bar"  [ngStyle]="{'background-color': headerStyles.backgroundColor}">
        <div class="container-responsive">
            <div class="d-flex items-center">
                <a routerLink="/" class="brother-logo mr-auto">
                    <img src="./assets/img/logo_brother.svg" alt="Brother logo" [ngStyle]="{'filter': headerStyles.logoFilter}">
                </a>
            </div>
        </div>
    </div>
</ng-container>

<app-main-header *ngIf="showFullMenu"></app-main-header>

<div class="adapter-body">
    <router-outlet></router-outlet>
</div>
